const TESTING_ENV = "test";
const PRODUCTION_BASE_PATH = "https://monday.com";
const isDevelopment = process.env.NODE_ENV === "development";
const isTesting = process.env.NODE_ENV === TESTING_ENV;
// Real prod vs staging: NODE_ENV is "production" on BOTH (staging runs the prod build), so it
// can't tell them apart — MONDAY_BASE_PATH can (see config/env/*). Use this, not a NODE_ENV
// check, whenever "am I on production" must exclude staging. A function (not a load-time
// constant) so it reflects the current env — tests flip MONDAY_BASE_PATH at runtime.
const isProduction = ()=>process.env.MONDAY_BASE_PATH === PRODUCTION_BASE_PATH;
module.exports = {
    isDevelopment,
    isTesting,
    isProduction
};
